import { hasPermission } from '../../system-navigation/model/permission-visibility.js';

export function resolveSystemUsersAccess(permissions) {
  const canView = hasPermission(permissions, 'user.view');
  const canCreate = hasPermission(permissions, 'user.create');
  const canUpdate = hasPermission(permissions, 'user.update');

  return {
    canView,
    canCreate,
    canUpdate,
    canViewSupportAccess: canView,
    canCreateSupportAccess: canCreate,
    canUpdateSupportAccess: canUpdate,
  };
}
